function toggleExpandedTabs(e) {
  e.preventDefault();
  e.stopPropagation();
  let el = document.getElementById('tab-expander');
  let dropdownCaret = document.getElementById('expand-tabs');

  if (el) {
    if (el.className.includes("collapsed-tabs")) {
      el.classList.toggle("collapsed-tabs")
      dropdownCaret.innerHTML = "&#9650;";
    } else {
      el.classList.toggle("collapsed-tabs")
      dropdownCaret.innerHTML = "&#9660;";
    }
  }
};

function toggleHidden(id) {
  let el = document.getElementById(id);

  if (el) {
    el.classList.toggle("hidden")
  }
};


export default { toggleExpandedTabs, toggleHidden }
